

<div class="columns-wrapper" [formGroup]="form">

  <!-- ── LEFT COLUMN ──────────────────────────────────────────────────── -->
  <div class="column">

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Basic Information
      </div>
      <div class="section-content">
        <div class="form-field-container">
          <mat-form-field appearance="fill" class="form-field" subscriptSizing="dynamic">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name">
            <mat-error>Name is required</mat-error>
          </mat-form-field>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Country</mat-label>
              <mat-select formControlName="countryId">
                @for (country of countries; track country.id) {
                  <mat-option [value]="country.id">{{ country.name }}</mat-option>
                }
              </mat-select>
              <mat-error>Country is required</mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Stock Exchange</mat-label>
              <mat-select formControlName="stockExchangeId">
                @for (exchange of stockExchanges; track exchange.id) {
                  <mat-option [value]="exchange.id">{{ exchange.name }}</mat-option>
                }
              </mat-select>
              <mat-error>Stock Exchange is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Currency</mat-label>
              <mat-select formControlName="currencyId">
                @for (currency of currencies; track currency.id) {
                  <mat-option [value]="currency.id">{{ currency.name }}</mat-option>
                }
              </mat-select>
              <mat-error>Currency is required</mat-error>
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Board Type</mat-label>
              <mat-select formControlName="boardSystem">
                @for (option of boardTypeOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Industry</mat-label>
              <mat-select formControlName="industryId">
                @for (industry of industries; track industry.id) {
                  <mat-option [value]="industry.id">{{ industry.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Super Sector</mat-label>
              <mat-select formControlName="superSectorId">
                @for (superSector of superSectors; track superSector.id) {
                  <mat-option [value]="superSector.id">{{ superSector.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Sector</mat-label>
              <mat-select formControlName="sectorId">
                @for (sector of sectors; track sector.id) {
                  <mat-option [value]="sector.id">{{ sector.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Sub Sector</mat-label>
              <mat-select formControlName="subSectorId">
                @for (subSector of subSectors; track subSector.id) {
                  <mat-option [value]="subSector.id">{{ subSector.name }}</mat-option>
                }
              </mat-select>
              <mat-error>Sub Sector is required</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </section>

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Market Information
      </div>
      <div class="section-content">
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Stock Symbol</mat-label>
              <input matInput formControlName="stockSymbol">
            </mat-form-field>
          </div>
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>ISIN</mat-label>
              <input matInput formControlName="isin">
            </mat-form-field>
          </div>
        </div>
        <div class="form-field-container form-field-container-with-columns">
          <div class="form-field-container-half">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Year Went Public</mat-label>
              <input matInput type="text" formControlName="yearWentPublic"
                     maxlength="10"
                     (focus)="onDateFocus($event)" (blur)="onDateBlur($event)"
                     (input)="onYearDateInput($event)">
            </mat-form-field>
          </div>
        </div>
      </div>
    </section>

  </div>

  <!-- ── RIGHT COLUMN ─────────────────────────────────────────────────── -->
  <div class="column">

    <section class="section-container nrg-border-radius-second-level">
      <div class="section-header">
        Active Measurements
      </div>
      <div class="section-content">
        <div class="section-field">
          <div class="select-with-button">
            <mat-form-field appearance="fill" class="form-field">
              <mat-select [value]="selectedMeasurements" (selectionChange)="onMeasurementsSelectionChange($event)" placeholder="Select Measurements" multiple>
                @for (measurement of measurements; track measurement) {
                  <mat-option [value]="measurement">{{ measurement }}</mat-option>
                }
                <mat-select-trigger>
                  @if (selectedMeasurements.length > 0) {
                    {{ selectedMeasurements[0] }}
                    @if (selectedMeasurements.length > 1) {
                      <span class="additional-count">
                        +{{ selectedMeasurements.length - 1 }} more
                      </span>
                    }
                  }
                </mat-select-trigger>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button type="button" (click)="selectAllMeasurements()" matTooltip="Select all measurements">
              <mat-icon>select_all</mat-icon>
            </button>
            <button mat-icon-button type="button" (click)="deselectAllMeasurements()" matTooltip="Deselect all measurements">
              <mat-icon>deselect</mat-icon>
            </button>
          </div>
        </div>
        <div class="section-selections">
          <mat-chip-set aria-label="Selected measurements">
            @for (year of selectedMeasurements; track year) {
              <mat-chip class="chip-basic-item">{{ year }}</mat-chip>
            }
          </mat-chip-set>
        </div>
      </div>
    </section>

    @if (isEditMode && companyData) {
      <section class="section-container nrg-border-radius-second-level">
        <div class="section-header">
          Transferred
        </div>
        <div class="section-content">
          <div class="transferred-status">
            @if (companyData.isTransferred) {
              <mat-icon class="status-icon status-yes">check_circle</mat-icon>
              <span>Yes</span>
            } @else {
              <mat-icon class="status-icon status-no">cancel</mat-icon>
              <span>No</span>
            }
          </div>
        </div>
      </section>
    }

  </div>

</div>

<div class="toolbar">
  <span class="spacer"></span>
  <button mat-flat-button color="primary" type="button" (click)="onSave()" [disabled]="!hasChanges">
    <mat-icon>save</mat-icon>
    Save
  </button>
</div>
